export const currentBuildVersion = "006";
